import { useState } from 'react';
import { PlusIcon } from '../../../../utils/SVGIcon';
import { useAdminInfo } from '../AdminInfoProvider';
import AddressAddModal from './AddressAddModal';

// -- No Address Then Show Plus Icon
function NoAddressData({ title, disabled }) {
    const [show, setShow] = useState(false);
    const { customerDetailsData } = useAdminInfo();
    return (
        <div
            className={`address-card flex flex-col gap-6 w-full min-h-[250px] p-4 border border-primary-100 rounded-2xl box-border ${
                disabled ? 'grayscale pointer-events-none' : ''
            }`}
        >
            <div
                role="button"
                tabIndex={-1}
                onClick={() => setShow(true)}
                className="flex flex-col justify-center items-center h-full bg-secondary-50 hover:bg-secondary-200 rounded-xl transition"
            >
                <h1 className="text-primary text-lg font-medium capitalize">{`${title} Address`}</h1>
                <button type="button" className=" text-secondary  w-8 h-8">
                    <PlusIcon />
                </button>
            </div>

            {show && (
                <AddressAddModal
                    show={show}
                    setShow={setShow}
                    title={title}
                    customerData={customerDetailsData}
                />
            )}
        </div>
    );
}

export default NoAddressData;
